import * as Yup from "yup";

import { yupObjectValidation } from "../../validationServices";

export const useForceResetPasswordValidationSchema = () => {
  const initialValues = {
    password: "",
    cPassword: "",
  };

  const validationSchema = {
    password: yupObjectValidation.password,
    cPassword: yupObjectValidation.change_password,
  };

  const forceResetPasswordValidationSchema = Yup.object().shape(
    validationSchema,
  );

  return {
    initialValues,
    forceResetPasswordValidationSchema,
  };
};
